import React from 'react';
import { Space, Input, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { spacing } from './tokens';

const { Search } = Input;
const { Option } = Select;

interface FilterOption {
  value: string;
  label: string;
}

interface FilterBarProps {
  searchPlaceholder?: string;
  onSearch?: (value: string) => void;
  searchValue?: string;
  filters?: Array<{
    key: string;
    placeholder: string;
    options: FilterOption[];
    value?: string;
    onChange?: (value: string) => void;
  }>;
  style?: React.CSSProperties;
}

export const FilterBar: React.FC<FilterBarProps> = ({
  searchPlaceholder = 'Tìm kiếm...',
  onSearch,
  searchValue,
  filters = [],
  style,
}) => {
  return (
    <div style={{ marginBottom: spacing.md, ...style }}>
      <Space wrap style={{ width: '100%' }}>
        {onSearch && (
          <Search
            placeholder={searchPlaceholder}
            onSearch={onSearch}
            allowClear
            style={{ width: 300, maxWidth: '100%' }}
            enterButton={<SearchOutlined />}
          />
        )}
        {filters.map(filter => (
          <Select
            key={filter.key}
            placeholder={filter.placeholder}
            style={{ width: 200, minWidth: 150 }}
            allowClear
            value={filter.value}
            onChange={filter.onChange}
          >
            {filter.options.map(option => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        ))}
      </Space>
    </div>
  );
};
